import { appConstants } from "../constants/app.constants";
import { appService, usageService, commonService } from "../services/index";
import { store } from "../helpers/store";

export const appActions = {
  getParametersWidgets,
  getConnectionDetails,
  getAppLogo,
  browserDetect
};

function getParametersWidgets() {
  return (dispatch) => {
    appService.getParametersWidgets().then((res) => {
      if (res) {
        dispatch(success(res));
      } else {
        dispatch(failure());
      }
    });
  };

  function success(params) {
    return { type: appConstants.PARAMETER_WIDGET_SUCCESS, params };
  }
  function failure() {
    return { type: appConstants.PARAMETER_WIDGET_FAILURE };
  }
}

function browserDetect() {
  return dispatch => {
    let userAgent = navigator.userAgent;
  let browserName;
         
 if(userAgent.match(/chrome|chromium|crios/i)){
     browserName = "chrome";
   }else if(userAgent.match(/firefox|fxios/i)){
     browserName = "firefox";
   }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
   }else if(userAgent.match(/opr\//i)){
     browserName = "opera";
   } else if(userAgent.match(/edg/i)){
     browserName = "edge";
   }else{
      browserName="No browser detection";
   }

   dispatch({ type: appConstants.BROWSER_DETECT, browserName })
  }
}

function getConnectionDetails(accountId, mobileNo, emailId) {
  return (dispatch) => {
    dispatch(success(accountId, mobileNo, emailId));
  };

  function success(connection, mobileNo, email) {
    return {
      type: appConstants.BALANCE_VIEW_SUCCESS,
      connection,
      mobileNo,
      emailId,
    };
  }
}

function getAppLogo(tenant) {
  return (dispatch) => {
    commonService.getAssestUrl(tenant).then((res) => {
      if (res) {
        dispatch(success(res));
      } else {
        dispatch(failure());
      }
    });
  };

  function success(logoResponse) {
    return { type: appConstants.APPLOGO_SUCCESS, logoResponse };
  }
  function failure() {
    return { type: appConstants.APPLOGO_FAILURE };
  }
}
